import { resetPageBehaviorState } from './behavior-state.js';
import { trackCursorBehavior } from './track-cursor-behavior.js';
import { trackFocusIntersection } from './track-focus-intersection.js';
import { watchPageNavigation } from '../watch-page-navigation.js';

let stopWatchers: (() => void) | null = null;
let started = false;

function attachBehaviorWatchers(): () => void {
  let teardown = startInner();

  function startInner(): () => void {
    resetPageBehaviorState();
    const stopCursor = trackCursorBehavior();
    const stopFocus = trackFocusIntersection();
    return () => {
      stopCursor();
      stopFocus();
    };
  }

  const stopNavigation = watchPageNavigation({
    onNavigate: () => {
      teardown();
      teardown = startInner();
    },
    onContentChange: () => {
      teardown();
      teardown = startInner();
    },
  });

  return () => {
    teardown();
    stopNavigation();
  };
}

/** Start cursor + focus watchers once (CONTEXT_ENABLED). Re-binds on SPA navigation. */
export function startPageBehaviorWatchers(): () => void {
  if (typeof window === 'undefined') return () => {};

  if (started) return () => {};

  started = true;
  stopWatchers = attachBehaviorWatchers();

  return () => stopPageBehaviorWatchers();
}

export function stopPageBehaviorWatchers(): void {
  stopWatchers?.();
  stopWatchers = null;
  started = false;
  resetPageBehaviorState();
}

export function isPageBehaviorWatchersActive(): boolean {
  return started;
}
